import { Component } from '@angular/core';

@Component({
    selector: 'app-en-attente',
    templateUrl: 'en-attente.component.html',
})
export class EnAttenteComponent {}
